{
  "version": 1,
  "asset_id": "44593a11-efff-49db-9f6e-162955c8db39",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/44593a11-efff-49db-9f6e-162955c8db39/svc-google-business-profile-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/44593a11-efff-49db-9f6e-162955c8db39/svc-google-business-profile-640.avif",
  "original_filename": "svc-google-business-profile-640.avif",
  "size": 3452,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:50Z"
}
